import { isCopywriteBooking } from './orderType';

/**
 * Extra recipients of the booking workflow emails (option request, 1st option, modification,
 * booking confirmation, release).
 *
 * Copywrite orders are run by Claudia Gabor, who has no access to talents@set-cast.com and
 * must not get it (Ariane, 2026-09-21). She is therefore put in CC — CC only, and only on
 * Copywrite bookings. talents@set-cast.com stays in every email so SetCast keeps the overview.
 */
export const COPYWRITE_CC_EMAILS = ['c.gabor@orendtstudios.com'];

/**
 * CC list for an email about `booking`: the existing CC entries plus the Copywrite contacts
 * when the booking is a Copywrite order. Returns undefined when there is nothing to CC, so it
 * can be spread straight into the email payload (`cc: copywriteCcList(booking)`).
 */
export function copywriteCcList(booking, existingCc = []) {
  const base = Array.isArray(existingCc) ? existingCc : (existingCc ? [existingCc] : []);
  const extra = isCopywriteBooking(booking) ? COPYWRITE_CC_EMAILS : [];
  const merged = [...new Set([...base, ...extra].map((e) => String(e || '').trim()).filter(Boolean))];
  return merged.length ? merged : undefined;
}

/** `{ cc: [...] }` for a Copywrite booking, `{}` otherwise — for spreading into emailData. */
export function copywriteCc(booking) {
  const cc = copywriteCcList(booking);
  return cc ? { cc } : {};
}
